import { createReducer, on } from "@ngrx/store";
import { raceMarketDataModel } from "@sports-models/index";
import * as SportsbookActions from "../../../../sports/stores/sportsbook/sportsbook.actions";

export const initialState: raceMarketDataModel = {
  filters: [
    { index: 0, name: "tWin", navigate: "win" },
    { index: 1, name: "tTwin", navigate: "forecast" },
    { index: 2, name: "tTrio", navigate: "tricast" },
  ],
  selectedFilter: null,
  dropListEvents: [],
  dropListEventSelected: null,
  participants: "initialState",
};

export const SportsbookRaceMarketReducer = createReducer(
  initialState,
  // Race Market
  on(SportsbookActions.setRaceMarket, (state, raceMarketData: raceMarketDataModel) => ({
    ...state,
    ...raceMarketData,
  })),
  on(SportsbookActions.clearRaceMarket, (state) => ({
    ...state,
    ...initialState,
  })),
);
